<template>
  <div id="adminCrmRedirect">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ crm }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Redirect</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
      <h1>Redirect</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content">
          <div class="tab-pane active" id="tabTableRedirect" role="tabpanel">
                  <div class="row align-btns" style="width:85%;">
                    <div class="col-lg-6">
                      <button id="btnAdd" type="button" class="btn btn-primary" @click="onClickNew">
                        <i class="fa fa-plus"></i>
                        <span>{{ add }}</span>
                      </button>
                       <button
                        id="btnSave"
                        type="button"
                        class="btn btn-success"
                        @click="saveNewRedirects"
                        :disabled="disableButton"
                      >
                        <i class="fa fa-floppy-o"></i>
                        <span>{{ save }}</span>
                      </button>
                    </div>
                  </div>
            <div class="card-body" style="padding:0px;">
              <bootstrapTable
                :configurations="TableConfiguration"
                :datas="tableData"
                id="tableContents"
                ref="tableContents"
                :onCheck="onTableCheckRedirect"
                :results="tableRedirectResult"
              ></bootstrapTable>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabRedirectDetail" role="tabpanel">
            
               <div class="card-body" style="padding:30px;">
              <div class="row">
               <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                <pageDetail
                  functions="AdminSettingRedirect"
                  :configurations="DetailConfiguration"
                  :jsonValue="detailRedirectData"
                ></pageDetail>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="cancelNewRedirect"
                  ><i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
                  <button type="button" class="btn btn-success" @click="saveNewRedirect"><i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import Select2 from "@/components/Select2.vue";
import PageDetail from "@/components/PageDetail.vue";
export default {
  name: "adminCrmRedirect",
  components: {
    BootstrapTable,
    Select2,
    PageDetail,
  },
  data: function () {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      save: dictionaryHelpers.getDictionary("Save"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      DetailConfiguration: [],
      tableRedirectResult: [],
      detailRedirectData: {},
      TableConfiguration: [],
      rowIdSelected: 0,
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null },
      },
      tableData: [],
      disableButton: true,
      url: window.location.pathname,
    };
  },
  created() {
    var adminCrmRedirect = this;
    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function (result) {
      adminCrmRedirect.TableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
      adminCrmRedirect.DetailConfiguration = result.data.tabsConfigurations[0].pageConfigurations;
      adminCrmRedirect.loadTable();
    });
  },
  methods: {
    loadTable() {
      var adminCrmRedirect = this;
      redirectServices.getAll(function (result) {
        adminCrmRedirect.tableData = result.data;
        spinnerHelpers.hide();
      });
    },
    onTableCheckRedirect() {
      var countRowSelected = this.$refs.tableContents.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminCrmRedirect = this;
      adminCrmRedirect.loadTable(value);
      spinnerHelpers.hide();
    },

    CheckOnlineRedirectFormatter(value, row, index, field){
     var adminCrmRedirect = this;
      console.log(row); 
      if(row.Active){
      var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="Active" class="switch-input" checked="checked" onclick="adminCrmRedirect.__vue__.onChangeCheckOnlineDetailContact(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      } else {
        var newList = '<div class="container-fluid nopadding" style="min-width:80px;"><label class="switch switch-pill switch-primary" style="margin: 2px; margin-bottom: -2px; vertical-align: bottom" ><input type="checkbox"  id="Active" class="switch-input" onclick="adminCrmRedirect.__vue__.onChangeCheckOnlineDetailContact(' + row.id + ')"><span class="switch-slider" data-on data-off></span></label></div>'; 
      }
      return newList;
    },

    onChangeCheckOnlineDetailContact(id) {
      console.log(id);
      var adminCrmRedirect = this;
      var data = {
        IdRedirect: id
      //  group_newsletter_id: this.rowIdSelected,
      };
      redirectServices.insertRedirectCheck(data, function (result) {
        notificationHelpers.success("Aggiornamento avvenuto correttamente");
      });
        adminCrmRedirect.loadTable();
    },
    

     RedirectFormatter(value, row, index, field) {
      var adminCrmRedirect = this;
      var html = "";
      html +=
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      html +=
        '<button class="btn btn-success" onclick="adminCrmRedirect.__vue__.viewDatailInfo(' +
        row.id +
        ')"><i class="fa fa-pencil"/></button>';
      html +=
        '<button class="btn btn-danger" onclick="adminCrmRedirect.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';

      html += "</div>";
      return html;
    },

    viewDatailInfo(id) {
      spinnerHelpers.show();
      var adminCrmRedirect = this;
      this.rowIdSelected = id;

      $.each(this.tableData, function (i, row) {
        if (adminCrmRedirect.rowIdSelected == row.id) {
          adminCrmRedirect.detailRedirectData = row;
        }
      });
      $("#tabTableRedirect").removeClass("active");
      $("#tabRedirectDetail").addClass("active");
      spinnerHelpers.hide();
    },
    delete(id) {
      var adminCrmRedirect = this;
      spinnerHelpers.show();
      redirectServices.del(id, function () {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
          adminCrmRedirect.loadTable();
          window.scrollTo(0, 0);
      });
    },

    onClickNew() {
      spinnerHelpers.show();
      this.detailRedirectData = {};
      $("#tabTableRedirect").removeClass("active");
      $("#tabRedirectDetail").addClass("active");
      spinnerHelpers.hide();
    },

    cancelNewRedirect() {
      spinnerHelpers.show();
      this.detailRedirectData = {};
      $("#tabTableRedirect").addClass("active");
      $("#tabRedirectDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    saveNewRedirects() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSave();
      }
    },

    executeSave() {
      spinnerHelpers.show();
      var adminCrmRedirect = this;
      this.rowsSelected = 0;
      this.tableRedirectResult = [];

      $.each(this.$refs.tableContents.getRowSelected(), function (i, row) {
        var rowToSave = row;
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        adminCrmRedirect.rowsSelected = adminCrmRedirect.rowsSelected + 1;
        console.log(rowToSave);
        redirectServices.updateTable(rowToSave, function () {
            adminCrmRedirect.checkAllIsSaved();
            adminCrmRedirect.tableRedirectResult.push({
              id: rowToSave.id,
              success: true,
            });
            notificationHelpers.success(adminCrmRedirect.updateCompleted);
          },
          function (response) {
            adminCrmRedirect.checkAllIsSaved();
            adminCrmRedirect.tableRedirectResult.push({
              id: rowToSave.id,
              success: false,
              message: response,
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable();
      }
    },

    saveNewRedirect() {
      spinnerHelpers.show();
      var adminCrmRedirect = this;
      this.detailRedirectData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (functionHelpers.isValued(this.rowIdSelected) && this.rowIdSelected > 0) {
        this.detailRedirectData.id = this.rowIdSelected;

        redirectServices.update(this.detailRedirectData, function (result) {
          notificationHelpers.success(adminCrmRedirect.updateCompleted);
          adminCrmRedirect.loadTable();
          $("#tabTableRedirect").addClass("active");
          $("#tabRedirectDetail").removeClass("active");
        });
      } else {
        redirectServices.insert(this.detailRedirectData, function (result) {
          notificationHelpers.success(adminCrmRedirect.insertCompleted);
          adminCrmRedirect.loadTable();
          $("#tabTableRedirect").addClass("active");
          $("#tabRedirectDetail").removeClass("active");
        });
      }
    },
  },
};
</script>
<style scoped>
.card-title-admin .card {
  background: transparent;
  border: 0px;
}
.card-title-admin h1 {
  font-size: 40px;
  font-weight: lighter;
  color: #303c54;
}

.align-btns {
    position: absolute;
    z-index: 1;
    margin-top: 10px;
}
.span {
  position: absolute;
  margin-top: 75px;
}
</style>
